import {
  Toolbar,
  ToolbarButton,
} from "@fluentui/react-components";
import {
  AddRegular,
  ArrowClockwiseRegular
} from "@fluentui/react-icons";


export interface IConfigurationDataToolbarProps {
  onAddSettings(): void;
  onRefresh(): void;
}

export const ConfigurationDataToolbar = (props: IConfigurationDataToolbarProps) => {
  const { onAddSettings, onRefresh } = props;
  return (
    <Toolbar aria-label="Horizontal Button" style={{ marginTop: '20px', marginBottom: '20px' }}>
      <ToolbarButton icon={<AddRegular />} onClick={onAddSettings}>
        Add
      </ToolbarButton>
      <ToolbarButton icon={<ArrowClockwiseRegular />} onClick={onRefresh}>
        Refresh
      </ToolbarButton>
    </Toolbar>);
};